<template>
  <div class="col-6 d-none d-md-block">
    <img
      :src="require(`../../assets/projects/${imageSource}.webp`)"
      :alt="imageSource"
      class="image"
      :class="{
        'right-image': isRight,
        'left-image': !isRight,
        'small-image': isSmallImage,
        'large-image': isLargeImage,
      }" />
  </div>
</template>

<script setup lang="ts">
import {defineProps} from 'vue';

defineProps<{
  imageSource: string;
  isRight: boolean;
  isSmallImage: boolean;
  isLargeImage: boolean;
}>();
</script>

<style lang="scss" scoped>
.image {
  position: absolute;
  width: 85%;
  height: auto;
  transition: transform 0.3s ease-in-out;
}

.small-image {
  width: 100%;
  height: auto;
  bottom: -5%;
}

.large-image {
  width: 60%;
  height: auto;
}

.right-image {
  right: -10%;
}

.left-image {
  left: -10%;
}

.card:hover .right-image {
  transform: rotate(-3deg) translate(-3%, 0%);
}

.card:hover .left-image {
  transform: rotate(3deg) translate(3%, 0%);
}
</style>
